<template>
  <Transition
    :appear="appear"
    name="def-slide-right"
    class="def-slide-right"
    @after-leave="$emit('afterLeave')"
  >
    <slot />
  </Transition>
</template>

<script>
export default {
  name: 'DefSlideRight',
  props: ['appear'],
};
</script>

<style lang="scss" scoped>
.def-slide-right-enter-active,
.def-slide-right-leave-active {
  transition: transform 0.5s ease;
}
.def-slide-right-enter-from,
.def-slide-right-leave-to {
  transform: translateX(100%);
}
</style>
